function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSubscribeEmail = function SvgSubscribeEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-816 -4576)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(816 4576)",
    style: {
      fill: "#f7f7f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.011 24.488 23.308-9.994L3.011 4.5 3 12.273l5.83 2.221L3 16.715Z",
    transform: "translate(826 4586.5)",
    style: {
      fill: "#202020"
    }
  })));
};

export { SvgSubscribeEmail as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='50' height='50' viewBox='0 0 50 50'%3e%3cdefs%3e%3cstyle%3e.a%7bfill:%23f7f7f7;%7d.b%7bfill:%23202020;%7d%3c/style%3e%3c/defs%3e%3cg transform='translate(-816 -4576)'%3e%3ccircle class='a' cx='25' cy='25' r='25' transform='translate(816 4576)'/%3e%3cg transform='translate(829 4591)'%3e%3cpath class='b' d='M3.011,24.488l23.308-9.994L3.011,4.5,3,12.273l5.83,2.221L3,16.715Z' transform='translate(-3 -4.5)'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";